<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <h1 class="text-center">Go I Assessoria Digital e Desenvolvimento</h1>
        <h6 class="text-center">A melhor do BRASIL</h6>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/views/layouts/Layout.vue'
import PageHeader from '@/components/commons/PageHeader.vue'

export default {
  name: 'Home',

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: 'Home',
      items: [
        {
          text: 'Home',
          active: true,
        },
      ],
    }
  },
}
</script>
